import { converters as tableConverters } from 'store/table';
import { IAdminTransmissionAct, IBaseAdminTransmissionAct } from 'types/income';
import {
  convertBaseTransmissionAct,
  convertTransmissionAct,
} from 'store/transmission-acts';
import { loaders } from './admin-transmission-acts.loaders';
import {
  AdminBaseTransmissionAct,
  AdminTransmissionAct,
} from './admin-transmission-acts.types';

const convertAdminBaseTransmissionAct = (
  transmissionAct: IBaseAdminTransmissionAct,
): AdminBaseTransmissionAct => {
  return {
    ...convertBaseTransmissionAct(transmissionAct),
  };
};

const convertAdminTransmissionAct = (
  transmissionAct: IAdminTransmissionAct,
): AdminTransmissionAct => {
  return {
    ...convertTransmissionAct(transmissionAct),
  };
};

const convertAdminTransmissionActs = (
  transmissionActs: IBaseAdminTransmissionAct[],
): AdminBaseTransmissionAct[] => {
  return transmissionActs.map(convertAdminBaseTransmissionAct);
};

export const converters = {
  getTransmissionActs: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getTransmissionActs>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertAdminTransmissionActs(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getTransmissionAct: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getTransmissionAct>>) => {
    return convertAdminTransmissionAct(data);
  },
};
